import React, { useState, useEffect, useCallback } from "react";
import { Modal, Button, Progress } from "antd";
import axios from "axios";

const UpdateDetector = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentVersion, setCurrentVersion] = useState(null);
  const [countdown, setCountdown] = useState(5);

  const fetchVersion = useCallback(async () => {
    try {
      const response = await axios.get(`/meta.json?v=${new Date().getTime()}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching version:", error);
      return null;
    }
  }, []);

  const clearCacheAndReload = () => {
    // 1. Unregister Service Workers
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => registration.unregister());
      });
    }

    // 2. Clear Cache Storage API
    if (window.caches) {
      caches.keys().then((names) => {
        for (let name of names) caches.delete(name);
      });
    }

    // 3. Force reload from server
    window.location.reload(true);
  };

  const handleUpdate = useCallback(() => {
    clearCacheAndReload();
  }, []);

  useEffect(() => {
    const checkUpdate = async () => {
      const latestData = await fetchVersion();
      if (!latestData) return;

      if (!currentVersion) {
        setCurrentVersion(latestData.buildDate);
        return;
      }

      if (latestData.buildDate !== currentVersion) {
        setIsModalVisible(true);
      }
    };

    checkUpdate();
    const interval = setInterval(checkUpdate, 30 * 60 * 1000);

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        checkUpdate();
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      clearInterval(interval);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [currentVersion, fetchVersion]);

  useEffect(() => {
    let timer;
    if (isModalVisible && countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    } else if (isModalVisible && countdown === 0) {
      handleUpdate();
    }
    return () => clearInterval(timer);
  }, [isModalVisible, countdown, handleUpdate]);

  const handleLater = () => {
    setIsModalVisible(false);
    setCountdown(5);
  };

  return (
    <Modal
      title="Update Available"
      open={isModalVisible}
      closable={false}
      footer={[
        <Button key="refresh" type="primary" onClick={handleUpdate}>
          Refresh Now
        </Button>,
        <Button key="later" onClick={handleLater}>
          Later
        </Button>,
      ]}
    >
      <div style={{ textAlign: "center", padding: "20px 0" }}>
        <Progress
          type="circle"
          percent={(countdown / 5) * 100}
          format={() => `${countdown}s`}
          width={80}
          strokeColor="#1890ff"
        />
        <p style={{ marginTop: "20px" }}>
          A new version of EquityEdge Admin is available. Refreshing
          automatically in {countdown} seconds...
        </p>
      </div>
    </Modal>
  );
};

export default UpdateDetector;
